import { useId } from 'react';
import { Trans } from 'react-i18next';

import { ExternalLink } from '~/components';
import { Field, Radio } from '~/components/Form';

import type { FieldsetProps as Props } from './types';

import {
  legendStyle,
  optionsStyle,
  otherFormStyle,
  wizardContentStyle,
} from '../CreateCustomConditionModal/CreateCustomConditionModal.css';

export const Fieldset = <Value,>({ children, footer, onValueChange, step, value }: Props<Value>) => {
  const legendId = useId();

  return (
    <fieldset className={wizardContentStyle}>
      <legend className={legendStyle} id={legendId}>
        <Trans components={{ a: <ExternalLink /> }} i18nKey={`settings:general.customConditions.wizard.${step}.question`} />
      </legend>

      {/* `Radio.Root` and `Checkbox.Root` render a base-ui Field.Item, which needs a Field.Root ancestor. */}
      <Field.Root name={step}>
        {onValueChange ? (
          // The legend names the outer fieldset, not the nested radiogroup, so point the group at it.
          <Radio.Group<Value | null>
            aria-labelledby={legendId}
            className={optionsStyle}
            onValueChange={(nextValue) => nextValue !== null && onValueChange(nextValue)}
            value={value ?? null}
          >
            {children}
          </Radio.Group>
        ) : (
          <div className={optionsStyle}>{children}</div>
        )}
      </Field.Root>

      {footer && <div className={otherFormStyle}>{footer}</div>}
    </fieldset>
  );
};
